<template>
  <BaseCard>
    <BaseCardHeader>
      <div class="leading-normal">Role info</div>
    </BaseCardHeader>
    <BaseCardBody>
      <span class="text-gray-600"> Description </span>
      <h6 v-if="role.description">
        {{ role.description }}
      </h6>
      <h6 v-else>-</h6>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
export default {
  props: {
    role: {
      type: Object,
      required: true,
    },
  },
};
</script>
